import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import AdministratorsStore from '../Administrators/AdministratorsStore';
import RoleAccessStore from '../RoleAccess/RoleAccessStore';
import { apiCall } from '../../API';
import AsyncActionStore from '../AsyncActionStore';
import FlagStore from '../FlagStore';
import { ROLE_FULL_ACCESS, ROLE_READ_ONLY } from '../Administrators/AdministratorModalStore';

export default class ConsoleSamlAccessStore {
    static PropType = PropTypes.shape({
        roleAccess: RoleAccessStore.PropType.isRequired,
        userAccess: AdministratorsStore.PropType.isRequired,

        samlSSOEnabled: FlagStore.PropType.isRequired,
        configStatus: AsyncActionStore.PropType.isRequired,

        loadConfigurations: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ConsoleSamlAccessStore */{
            roleAccess: new RoleAccessStore({ possibleRoles: [ROLE_FULL_ACCESS, ROLE_READ_ONLY] }),
            userAccess: new AdministratorsStore({
                possibleRoles: [ROLE_FULL_ACCESS, ROLE_READ_ONLY],
                apiList: apiCall('/console/meta/user/get'),
                apiCreate: apiCall('/console/meta/user/create'),
                apiUpdate: apiCall('/console/meta/user/update'),
                apiDelete: apiCall('/console/meta/user/delete'),
            }),

            apiLoadMetaConfig: apiCall('/console/meta/config'),

            samlSSOEnabled: new FlagStore(false),
            configStatus: new AsyncActionStore(),
        }, data);
    }

    loadConfigurations = action(() => {
        if (!this.configStatus.isLoading) {
            this.configStatus.setLoading(this.apiLoadMetaConfig().then((config) => {
                this.samlSSOEnabled.setValue(config.metaEnabled);
            }));
        }
        return this.configStatus.promise;
    });

    setSamlSSODisabled = action(() => {
        this.samlSSOEnabled.setFalse();
    });
}
